import { PageLayout } from '@shared/widgets';

export const NotFoundPage = () => {
  return (
    <PageLayout>
      <div className='flex shrink-0 grow basis-full flex-col items-center justify-center'>404 page not found</div>
    </PageLayout>
  );
};
